module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMO20un///+RvN2Ftdp4rdZgns7z+PtHj8fn8Pja6fSdxOHKSsTAAAAACHRSTlMAYL//ACDP71kzCuAAAAEOSURBVHgB7djRboMwDIVhg4HGpCQ17/+wTScuNq/bkbDV3PA9wH91JILpZRjZYRymhqZpXthpmV+h+cZut7mFFg6wTDRwiIFGDjESYykxRow7IikitEqz+kNZvmRv6C6Huy+0FTmUDYdwB5ZAqD7km0c9G6oqP2g9GVIx9FwoyS8JhEAHlEBolbdWGDKy/CHjkB20ASZOcIhW2VAIdECJ4KAPaOKEB32wE8chFUhRyBCDjd6hK3SFrtAVukIqkH72c8S1yL9K/dAn2/+IAM8jI3d5aDW7vLX3eYz6n8dgmFr7/kLYiZfa5zfL/+MHhpk7/xzbie+9DgiOk0bYkSXs7BN1iAo7jUUe65qI8+ETtFNY9Ra2FQwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2195.png
// module id = 1317
// module chunks = 0